import ApiService from "@/services/api.service";

const route = "configurations";

const configurations = {
  all() {
    return new Promise((resolve, reject) => {
      ApiService.get(route).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(route, data).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default configurations;
